require('../components/map.js');
require('../components/form.js');
require('../components/location-content.js');